import React, { useState } from "react";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    care: "Not sure yet",
    message: "",
  });
  const [note, setNote] = useState("We'll get back to you within one business day.");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`New inquiry from ${form.name} — ${form.care}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\n` +
        `Phone: ${form.phone}\n` +
        `Email: ${form.email}\n` +
        `Care type: ${form.care}\n\n` +
        `Message:\n${form.message || "(no message provided)"}`
    );
    window.location.href = `mailto:care@askhemo.com?subject=${subject}&body=${body}`;
    setNote("Opening your email app to send this to care@askhemo.com...");
  };

  return (
    <section className="cta" id="contact">
      <div className="wrap">
        <div className="cta-grid">
          <div className="cta-left">
            <span className="eyebrow">Let's Find the Right Solution Together</span>
            <h2>Ready to talk through your family's next step?</h2>
            <p>Reach out for a free, no-pressure consultation. We'll listen to your situation and help you understand every option available — clearly, honestly, and with your loved one's best interest first.</p>
            <a className="btn" href="tel:9547080298">Call 954-708-0298</a>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="cf-name">Full name</label>
                  <input type="text" id="cf-name" name="name" required placeholder="Jane Rodriguez" value={form.name} onChange={handleChange} />
                </div>
                <div className="form-field">
                  <label htmlFor="cf-phone">Phone</label>
                  <input type="tel" id="cf-phone" name="phone" required placeholder="(954) 555-0123" value={form.phone} onChange={handleChange} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="cf-email">Email</label>
                  <input type="email" id="cf-email" name="email" required placeholder="jane@email.com" value={form.email} onChange={handleChange} />
                </div>
                <div className="form-field">
                  <label htmlFor="cf-care">Care type</label>
                  <select id="cf-care" name="care" value={form.care} onChange={handleChange}>
                    <option value="Not sure yet">Not sure yet</option>
                    <option value="Independent Living">Independent Living</option>
                    <option value="Assisted Living">Assisted Living</option>
                    <option value="Memory Care">Memory Care</option>
                    <option value="In-Home Care">In-Home Care</option>
                  </select>
                </div>
              </div>
              <div className="form-field">
                <label htmlFor="cf-message">How can we help?</label>
                <textarea id="cf-message" name="message" rows="4" placeholder="Tell us a little about your family's situation..." value={form.message} onChange={handleChange}></textarea>
              </div>
              <button type="submit" className="btn form-submit">Send Message</button>
              <p className="form-note">{note}</p>
            </form>
          </div>
          <div className="contact-card">
            <div className="contact-row">
              <svg viewBox="0 0 24 24"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.9 21 3 13.1 3 3.9c0-.6.4-1 1-1h3.2c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.4 0 .8-.2 1L6.6 10.8z" /></svg>
              <div><b>Phone</b><a href="tel:9547080298">954-708-0298</a></div>
            </div>
            <div className="contact-row">
              <svg viewBox="0 0 24 24"><path d="M2 5.5A1.5 1.5 0 0 1 3.5 4h17A1.5 1.5 0 0 1 22 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 18.5v-13zm2 .4v.3l8 5.6 8-5.6v-.3H4zm16 2.4-7.4 5.2a1 1 0 0 1-1.2 0L4 8.3V18h16V8.3z" /></svg>
              <div><b>Email</b><a href="mailto:care@askhemo.com">care@askhemo.com</a></div>
            </div>
            <div className="contact-row">
              <svg viewBox="0 0 24 24"><path d="M12 2a8 8 0 0 0-8 8c0 5.6 8 12 8 12s8-6.4 8-12a8 8 0 0 0-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" /></svg>
              <div><b>Service Area</b><span>South Florida to Orlando</span></div>
            </div>
            <div className="contact-row">
              <svg viewBox="0 0 24 24"><path d="M12 2 2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" /></svg>
              <div><b>Website</b><a href="https://www.askhemo.com" target="_blank" rel="noopener noreferrer">askhemo.com</a></div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Compassionate Senior Placement LLC. All rights reserved.</p>
          <div className="footer-right">
            <div className="footer-tagline">
              <span>Compassionate Care</span>
              <span className="heart">&hearts;</span>
              <span>Personalized Solutions</span>
              <span className="heart">&hearts;</span>
              <span>Peace of Mind</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
